// extracted by mini-css-extract-plugin
module.exports = {"addText":"InlineTextEditor_addText__1vVhg"};